import { gsap } from 'gsap';
import { throttle } from 'lodash';
import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';
import { openMinicart } from './minicart';

if (!window.dAgency) window.dAgency = {};

const backgroundContainer = document.querySelector('.header__background');

if (backgroundContainer) {
  const resizeCallback = throttle(
    () =>
      document.documentElement.style.setProperty(
        '--header-height',
        `${backgroundContainer.clientHeight}px`,
      ),
    500,
  );
  resizeCallback();
  window.addEventListener('resize', resizeCallback);

  if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
    const scrollCallback = throttle(
      () => (backgroundContainer.dataset.transparent = window.scrollY <= 0),
      500,
    );
    scrollCallback();
    window.addEventListener('scroll', scrollCallback);
  }
}

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  if (!$header.hasClass('header__transparent')) {
    var $mainContainer = $('main.main-content');
    $mainContainer.css('margin-top', headerHeight() + 'px');
    $header.css({
      top: '0px',
      position: 'absolute',
    });
  }

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css(
    'min-height',
    'calc(100vh - ' + headerHeight() + 'px)',
  );
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css(
      'min-height',
      'calc(100vh - ' + headerHeight() + 'px)',
    );
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');

  if (header) {
    const options = {
      tolerance: {
        up: 20,
        down: 20,
      },
      offset: 50,
      onPin: function () {
        if (this.elem) {
          setTimeout(() => {
            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              $deskSearchBar.css('top', headerHeight() + 'px');
              $searchPopup.css('top', headerHeight() + 'px');
            }
            if (
              $desktopMenu.length > 0 &&
              $desktopMenu.hasClass('header__desktop-menu--drawer')
            ) {
              $desktopMenu
                .find('.header__desktop-menu--drawer__second-level')
                .each(function () {
                  $(this).css(
                    'height',
                    'calc(100vh - ' + headerHeight() + 'px)',
                  );
                });
            }
          }, 100);
        }
      },
      onUnpin: function () {
        if (this.elem) {
          setTimeout(() => {
            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              $deskSearchBar.css('top', headerHeight() + 'px');
              $searchPopup.css('top', headerHeight() + 'px');
            }
            if (
              $desktopMenu.length > 0 &&
              $desktopMenu.hasClass('header__desktop-menu--drawer')
            ) {
              $desktopMenu
                .find('.header__desktop-menu--drawer__second-level')
                .each(function () {
                  $(this).css(
                    'height',
                    'calc(100dvh - ' + headerHeight() + 'px)',
                  );
                });
            }
          }, 100);
        }
      },
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  const overlay = document.querySelector('.header__transparent__background');

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
    overlay.style.opacity = '0';
  });
  $header.on('mouseleave', function () {
    if (
      $(window).scrollTop() === 0 &&
      $(window).outerWidth() > 1024 &&
      !$header.hasClass('force-opacity')
    ) {
      $header.addClass('apply-transparency');
    }

    overlay.style.opacity = '1';
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof window.dAgency.showNewsletterPopUp === 'function')
      window.dAgency.showNewsletterPopUp();
  });

  const $cartLink = $header.find('.cart-link');
  if ($cartLink.length) {
    $cartLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMinicart();
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  const $mobileMenuFooter = $mobileMenu.find(
    '.header__mobile-menu--drawer__footer',
  );
  if ($mobileMenu.length > 0) {
    if ($mobileMenu.hasClass('header__mobile-menu--dropdown')) {
      $mobileMenu.find('[data-link-opener]').on('click', function (e) {
        if (e.target.getAttribute('href')) return;

        const drawerAttribute = $(this).data('link-opener');
        const $drawer = $(this)
          .parent()
          .find('[data-level="' + drawerAttribute + '"]');
        if ($drawer.length > 0) {
          $drawer.addClass('open');
        }
      });

      const $menuCarousel = $mobileMenu.find(
        '.header__mobile-menu--dropdown__footer__carousel__blocks',
      );
      if ($menuCarousel.length > 0) {
        if ($menuCarousel[0].scrollWidth <= $menuCarousel[0].clientWidth) {
          $menuCarousel.css('justify-content', 'center');
        } else {
          window.dAgency.initDesktopSlider($menuCarousel[0], 2);
        }
      }
    } else if ($mobileMenu.hasClass('header__mobile-menu--drawer')) {
      const $firstLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__first-level__title',
      );
      $firstLevel.each(function () {
        const submenu = $(this).data('submenu');
        const $connectedSecondLevel = $mobileMenu.find(
          '.header__mobile-menu--drawer__second-level[data-submenu="' +
            submenu +
            '"]',
        );
        $(this).on('click', function (e) {
          if (
            e.target.getAttribute('href') ||
            $connectedSecondLevel.find(
              '.header__mobile-menu--drawer__second-level__title',
            ).length <= 0
          )
            return;

          $connectedSecondLevel.addClass('open');
          $mobileMenuFooter.addClass('hidden');
        });
      });

      const $secondLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__second-level',
      );
      $secondLevel.each(function () {
        const $level = $(this);
        const $close = $(this).find(
          '.header__mobile-menu--drawer__second-level__close',
        );
        $close.on('click', function () {
          $level.removeClass('open');
          $mobileMenuFooter.removeClass('hidden');
        });

        const $titles = $(this).find(
          '.header__mobile-menu--drawer__second-level__title',
        );
        $titles.each(function () {
          const accordionIndex = $(this).data('accordion-index');
          const $otherThirdLevels = $level.find(
            '.header__mobile-menu--drawer__third-level:not([data-accordion-index="' +
              accordionIndex +
              '"])',
          );
          const $connectedThirdLevel = $level.find(
            '.header__mobile-menu--drawer__third-level[data-accordion-index="' +
              accordionIndex +
              '"]',
          );

          $(this).on('click', function (e) {
            if (e.target.getAttribute('href')) return;

            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
              $connectedThirdLevel.slideUp();
            } else {
              $titles.removeClass('open');
              $otherThirdLevels.slideUp();
              $(this).addClass('open');
              $connectedThirdLevel.slideDown();
            }
          });
        });
      });
    }

    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    var tl = gsap.timeline();

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        $('html').addClass('translate');

        tl = gsap.timeline();
        tl.to(
          burgerTop,
          {
            rotate: 45,
            duration: 1,
            y: 7,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerMiddle,
          {
            scaleX: 0,
            duration: 1,
            opacity: 0,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerBottom,
          {
            rotate: -45,
            duration: 1,
            y: -7,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
      } else {
        $('html').css('overflow-y', '');
        $('html').removeClass('translate');

        tl = gsap.timeline();
        tl.to(
          burgerTop,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerMiddle,
          {
            scaleX: 1,
            duration: 1,
            opacity: 1,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerBottom,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
      }
    });

    $header.find('.drawer-icon-close').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      $mobileMenuFooter.removeClass('hidden');

      $('html').css('overflow-y', '');
      $('html').removeClass('translate');

      tl = gsap.timeline();
      tl.to(
        burgerTop,
        {
          rotate: 0,
          duration: 1,
          y: 0,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
      tl.to(
        burgerMiddle,
        {
          scaleX: 1,
          duration: 1,
          opacity: 1,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
      tl.to(
        burgerBottom,
        {
          rotate: 0,
          duration: 1,
          y: 0,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
    });

    $mobileMenuFooter.find('.clickable').on('click', function () {
      $mobileMenuFooter.removeClass('hidden');
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css(
          'height',
          'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)',
        );
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css(
          'transform',
          'translate3d(0, 0, 0)',
        );
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on(
      'click',
      function () {
        const $menu = $(this).closest('.header__mobile-menu__level');
        $menu.css('transform', '');
      },
    );
  }

  /* ======================== Top Bar Menu ======================== */
  const $preHeader = $header.find('.header__pre-header');

  if ($preHeader.length > 0) {
    const $inlineElements = $preHeader.find(
      '.header__pre-header__link.drawer-menu',
    );
    const $announcementBarHeight =
      $('.announcement-bar__background').outerHeight() || 0;

    const toggleDrawer = (element, action) => {
      element
        .find('.header__pre-header__drawer')
        .toggleClass('open', action)
        .css('top', $preHeader.outerHeight() + $announcementBarHeight + 'px');

      $inlineElements.toggleClass('open', action);
    };

    $inlineElements.on({
      mouseenter: function () {
        toggleDrawer($(this), true);
      },
      mouseleave: function () {
        toggleDrawer($(this), false);
      },
    });

    $preHeader.on('click', '.header__pre-header__close', function () {
      $inlineElements.find('.header__pre-header__drawer').removeClass('open');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');

  if ($desktopMenu.length > 0) {
    const $dropdownInlineElements = $desktopMenu.find(
      '.header__desktop-menu--dropdown__inline-elements__link',
    );
    $dropdownInlineElements.each(function () {
      if (
        $desktopMenu.hasClass('header__desktop-menu--dropdown--alternative') &&
        $(this).find('.header__desktop-menu--dropdown__navigation__element')
          .length <= 0
      )
        return;

      $(this).on('mouseenter', function () {
        $(this)
          .find('.header__desktop-menu--dropdown__dropdown-wrapper')
          .addClass('open');
        $header.addClass('force-opacity');
        $(this).addClass('active');
      });

      $(this).on('mouseleave', function () {
        $(this)
          .find('.header__desktop-menu--dropdown__dropdown-wrapper')
          .removeClass('open');
        $header.removeClass('force-opacity');
        $(this).removeClass('active');
      });
    });

    $desktopMenu
      .find('.header__desktop-menu--dropdown__navigation')
      .each(function () {
        const $mediaContainer = $(this).find(
          '.header__desktop-menu--dropdown__navigation__media',
        );
        const $titleWithImages = $(this).find('[data-image-src]');

        $titleWithImages.on('mouseenter', function () {
          const imgSrc = $(this).data('image-src');
          const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

          $mediaContainer
            .find(
              '.header__desktop-menu--dropdown__navigation__media__img.active',
            )
            .removeClass('active');
          $img.addClass('active');
        });
      });

    const $closeDesktopMenu = $desktopMenu.find('.close');

    if ($closeDesktopMenu.length > 0) {
      $closeDesktopMenu.on('click', function () {
        $(this).parent().removeClass('open');
      });
    }

    const $desktopMenuOverlay = $header.find(
      '.header__desktop-menu--dropdown__dropdown-overlay',
    );

    if ($desktopMenuOverlay.length > 0) {
      $desktopMenuOverlay.on('click', function () {
        $(this).prev().removeClass('open');
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    setTimeout(() => {
      $deskSearchBar.css('top', headerHeight() + 'px');
    }, 100);

    $(window).on('scroll', function () {
      $deskSearchBar.css('top', headerHeight() + 'px');
      setTimeout(() => {
        if (window.scrollY === 0) {
          $deskSearchBar.css('top', headerHeight() + 'px');
        }
      }, 1);
    });

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click touchstart', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $header.removeClass('force-opacity');
        $deskSearchBar.removeClass('open');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
});

const announcementBar = document.querySelector('.announcement-bar');

if (announcementBar) {
  const resizeCallback = throttle(
    () =>
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${announcementBar.clientHeight}px`,
      ),
    500,
  );
  resizeCallback();
  window.addEventListener('resize', resizeCallback);
} else {
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    `0px`,
  );
}

$(function () {
  const $announcementBar = $('.announcement-bar');
  if ($announcementBar.length > 0 && $announcementBar.children().length > 0) {
    const $firstAnnouncement = $announcementBar
      .find('.announcement-bar__announcement')
      .first();
    var announcementHeight = parseInt($firstAnnouncement.innerHeight());
    $announcementBar.css('height', announcementHeight + 'px');

    if ($announcementBar.children().length > 1) {
      $firstAnnouncement
        .clone()
        .attr('data-announcement-index', $announcementBar.children().length)
        .appendTo($announcementBar);
      const $announcements = $announcementBar.find(
        '.announcement-bar__announcement',
      );

      $announcements.each(function () {
        $(this).css('height', announcementHeight + 'px');
      });

      var activeIndex = 0;
      setInterval(() => {
        activeIndex++;
        if (
          !$announcementBar.find(
            '[data-announcement-index="' + activeIndex + '"]',
          ).length > 0
        ) {
          $announcements.each(function () {
            var transition = $(this).css('transition');
            $(this).css('transition', '0s');
            $(this).css('transform', 'translate3d(0, 0, 0)');

            // setTimeout is used to move the callback out of the stack and into the queue.
            // We need to use the queue to ensure that the transition is restored only after
            // the tansition is complete.
            setTimeout(() => {
              $(this).css('transition', transition);
            }, 0);
          });

          activeIndex = 1;
        }

        // setTimeout is used to move the callback out of the stack and into the queue.
        // We need to use the queue to ensure that the movement of the elements comes
        // after the position reset.
        setTimeout(() => {
          $announcements.each(function () {
            if ($announcementBar.data('direction') === 'horizontal') {
              $(this).css(
                'transform',
                'translate3d(calc(' + activeIndex + ' * -100%), 0, 0)',
              );
            } else {
              $(this).css(
                'transform',
                'translate3d(0, calc(' + activeIndex + ' * -100%), 0)',
              );
            }
          });
        }, 0);
      }, 5000);
    }
  }
});
